@if (showLoader$ | async) {
  <div class="ShowHideLoadingPanel">
    <img src="../assets/img/loader.gif" id="imgLoader" class="loadingImage" />
  </div>
}
